import character from 'assets/characters/character.png';
import sam from 'assets/characters/Sam.png';
import arabman from 'assets/characters/arabian.png';

export default [
  {
    id: 0,
    img: character,
    name: 'character'
  },
  {
    id: 1,
    img: sam,
    name: 'Sam'
  },
  {
    id: 2,
    img: arabman,
    name: 'Arab_Man_01_Unity'
  }
];

